var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"checkout-input-summary-line"},[_c('div',[_vm._v("Contact")]),_c('div',[_vm._v(_vm._s(_vm.name)+" ("+_vm._s(_vm.username)+")")]),_c('button',{staticClass:"btn btn-sm btn-link",on:{"click":_vm.change}},[_vm._v("Change")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }